import { z } from 'zod';

/**
 * Mirrors the server-side DTO. Messages are i18n keys resolved at render time,
 * so validation text follows the selected language.
 */
export const leadFormSchema = z.object({
  name: z.string().trim().min(2, 'validation.name').max(120),
  email: z.string().trim().email('validation.email').max(180),
  phone: z
    .string()
    .trim()
    .regex(/^[+0-9 ()/-]{6,25}$/, 'validation.phone')
    .or(z.literal(''))
    .optional(),
  street: z.string().trim().max(160).optional(),
  postalCode: z.string().trim().max(12).optional(),
  city: z.string().trim().max(120).optional(),
  availability: z.string().trim().max(300).optional(),
  interest: z.string().optional(),
  message: z.string().trim().max(4000, 'validation.tooLong').optional(),
  // DSGVO requires an explicit opt-in, so the box starts unchecked.
  consent: z.boolean().refine((v) => v === true, { message: 'validation.consent' }),
  /** Honeypot — hidden from humans, irresistible to bots. */
  website: z.string().max(0).optional(),
});

export type LeadFormValues = z.infer<typeof leadFormSchema>;

export const defaultLeadForm: LeadFormValues = {
  name: '',
  email: '',
  phone: '',
  street: '',
  postalCode: '',
  city: '',
  availability: '',
  interest: '',
  message: '',
  consent: false,
  website: '',
};
